<template>
  <div>
    <div v-if="loading">
      Aan het laden...
    </div>
    <div v-else-if="invalid_token" class="alert alert-danger">
      <h2>Let op!</h2>
      Geen toegang
    </div>
    <div v-else>
      <div>
        <div>
          <div class="d-flex">
            <h4 class="mr-auto">
              <span>Absentie {{ event.title }}</span>
            </h4>
            <div>
              <button
                v-if="!pdf_loading"
                class="btn btc-sm btn-dark"
                @click="downloadAbsentiePdf(event.id)"
              >
                Downloaden
              </button>
              <button v-else class="btn btc-sm btn-dark">
                Downloading...
              </button>
            </div>
          </div>

          <span>{{ event.date_start | formatDate }}</span>
        </div>
      </div>

      <div>
        <div class="row">
          <div class="col-12">
            <div class="form-check">
              <input type="checkbox" v-model="event.canceled" class="form-check-input" id="canceled" />
              <label class="form-check-label" for="canceled">Geannuleerd</label>
            </div>
          </div>
          <div class="col-12 opmerkingenCol">
            <label for="">Opmerkingen</label>
            <editor
              :id="'absentieRemarks' + event.id"
              v-model="event.remarks"
              :init="{
                height: 400,
                menubar: false,
                language: 'nl',
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
                                                                            alignleft aligncenter alignright alignjustify | \
                                                                            bullist numlist outdent indent | link code | paste | fullscreen | removeformat | help',
              }"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label for="" class="mt-3"
              >Een lid toevoegen aan de aanwezigheidslijst</label
            >
            <Select2
              @change="addUserToAttandee()"
              :options="
                users.map((d) => {
                  return { id: d.id, text: d.display_name };
                })
              "
              v-model="selected_user"
            ></Select2>
            <table style="height: 300px" class="table table-responsive">
              <thead>
                <tr>
                  <th>Lid</th>
                  <th>Aanwezig</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(user, index) in event.attendees"
                  :key="'absentie_user_' + index"
                >
                  <td>{{ user.display_name }}</td>
                  <td>
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :id="'absentieUser_' + user.id"
                        v-model="user.selected"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <button
              @click="updateEvent(event)"
              class="btn btn-dark text-white mt-2"
            >
              Opslaan
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
  props: {
    nextEvent: {
      default: null,
    },
  },
  data() {
    return {
      event: {},
      loading: true,
      invalid_token: true,
      users: [],
      selected_user: null,
      pdf_loading: false,
    };
  },

  mounted() {
    if (this.nextEvent == null) {
      let apiLink = "";

      if (this.$route.params.token) {
        apiLink = "/api/v1/event/absence/" + this.$route.params.token;
      } else if (this.$route.params.eventid) {
        apiLink = "/api/v1/events/" + this.$route.params.eventid;
      }

      this.$store
        .dispatch("get", apiLink)
        .then((data) => {
          if (this.$route.params.eventid) {
            this.event = data.data.data;
            this.invalid_token = false;
          } else if (data.data.success) {
            this.event = data.data.event;
            this.invalid_token = false;
          }
          this.formatAttendees();
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.event = this.nextEvent;
      this.invalid_token = false;
      this.loading = false;
      this.formatAttendees();
    }

    this.$store
      .dispatch("get", "/api/v1/users")
      .then((data) => {
        this.users = data.data.data;
      })
      .catch((error) => {
        console.log(error.request);
      });
  },

  methods: {
    formatAttendees() {
      this.event.attendees.map((user) => {
        user.selected = user.pivot.attend == 1 ? true : false;
        return user;
      });
    },

    updateEvent(event) {
      this.$store
        .dispatch("put", {
          details: event,
          endpoint: "api/v1/events/" + event.id,
        })
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addUserToAttandee() {
      let user = this.users.find((elm) => elm.id == this.selected_user);
      user.selected = true;
      this.event.attendees.push(user);
    },

    downloadAbsentiePdf(id) {
      this.pdf_loading = true;
      axios
        .get(
          process.env.VUE_APP_API_BASE_URL + `/api/v1/absentie/event/${id}/pdf`,
          {
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((data) => {
          this.pdf_loading = false;

          const type = data.headers["content-type"];
          const blob = new File([data.data], { type: type });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "pdf.pdf";
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.pdf_loading = false;
        });
    },
  },

  filters: {
    formatDate(value) {
      return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>
